import React, { useRef, useState } from "react";
import {
  CardInnerDiv,
  CardWrapper,
  ImgWrapper,
  MainSection,
  MainWrapper,
  TextBoxDiv,
} from "./elements";
import { Image } from "react-bootstrap";
import {
  arrowimg,
  c98cardimg,
  cardvideo,
  collectionimg,
  mintbtnimg,
  spaceimg,
  textBox2,
} from "assets";
import { MainCol, MainContainer, MainRow } from "components/common";
import { Link } from "react-router-dom";
const MyCollection = () => {
  const cardData = [
    {
      text: "Max supply: 5.555",
    },
    {
      text: "Phase 1: 100",
    },
    {
      text: "Max Mint per wallet: 5",
    },
    {
      text: "Stake - Play - Earn",
    },
    {
      text: "5 Elements: Fire, Water, Wood, Metal, & Earth",
    },
  ];

  return (
    <MainSection id="collection">
      <TextBoxDiv>
        <Image className="" src={textBox2} />
        <div>
          <h1 className="inner-text">
            Our <span>Collection</span>
          </h1>
        </div>
      </TextBoxDiv>
      <MainContainer fluid>
        <MainWrapper>
          <MainRow>
            <MainCol lg={6}>
              <ImgWrapper>
                <video
                  src={cardvideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls={false}
                />
              </ImgWrapper>
            </MainCol>
            <MainCol lg={1}></MainCol>
            <MainCol lg={5}>
              <CardWrapper>
                <Image src={c98cardimg} className="innerimg" />
                <CardInnerDiv>
                  <h1>
                    ELEMENTAL <span>LEGENDS</span>
                  </h1>
                  <div className="card-data">
                    {cardData.map((item) => (
                      <div className="content-div">
                        <Image src={arrowimg} />
                        <h5>{item.text}</h5>
                      </div>
                    ))}
                  </div>
                  <div className="price-div" style={{ marginTop: "1rem" }}>
                    <Image src={spaceimg} className="space-img" />
                    <p>Required</p>
                  </div>
                  <div className="price-div">
                    <h1>Price:</h1>
                    <p>25,555 $RETRO</p>
                  </div>
                  <Link to="minting-nft">
                    <div className="register-btn-div">
                      <Image
                        src={mintbtnimg}
                        alt="button img"
                        className="btn-img"
                      />

                      <h1>Mint Now</h1>
                    </div>
                  </Link>
                </CardInnerDiv>
              </CardWrapper>
            </MainCol>
          </MainRow>
        </MainWrapper>
      </MainContainer>
    </MainSection>
  );
};

export default MyCollection;
